import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	addNewGoal: {
		id: 'servicedesk-sla-settings.metrics.metric.editable.form.goals.add-goal-button.add-new-goal',
		defaultMessage: 'Add new goal',
		description: 'label for adding new goal button',
	},
	addGoal: {
		id: 'servicedesk-sla-settings.metrics.metric.editable.form.goals.add-goal-button.add-goal',
		defaultMessage: 'Add goal',
		description: 'label for adding new goal button',
	},
	warningLabel: {
		id: 'servicedesk-sla-settings.metrics.metric.editable.form.goals.add-goal-button.warning-label',
		defaultMessage: 'You’ve almost reached your goal limit for this service project.',
		description: 'text for info warning',
	},
	errorLabel: {
		id: 'servicedesk-sla-settings.metrics.metric.editable.form.goals.add-goal-button.error-label',
		defaultMessage:
			'You can’t add any more goals because you’ve reached your goal limit for this service project.',
		description: 'text for info warning',
	},
});
